import { mountDominoes } from '../render/three/dominoes/domino-game-app.js';

mountDominoes({ name: 'Block Dominoes', mode: 'block' }).catch((err) => {
  console.error('failed to mount block dominoes', err);
});
